import { RECEIVE_CREDENTIALS } from '../modules/authentication'

export default function createRavenMiddleware(raven, excludedActions = []) {
  // eslint-disable-next-line no-unused-vars,consistent-return
  return store => next => (action) => {
    if (excludedActions.indexOf(action.type) === -1) {
      raven.captureBreadcrumb({
        category: 'action',
        message: action.type,
        data: action.payload,
      })
    }

    if (
      action.type === RECEIVE_CREDENTIALS &&
      action.payload.user
    ) {
      raven.setUserContext({
        id: action.payload.user.id,
        email: action.payload.user.email,
        name: action.payload.user.first_name + ' ' + action.payload.user.last_name,
      })
    }

    return next(action)
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/middleware/raven.js